var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.751C12.2502 15.751 15.75 12.2512 15.75 8.00098C15.75 3.75817 12.2428 0.250977 7.99257 0.250977C3.74976 0.250977 0.25 3.75817 0.25 8.00098C0.25 12.2512 3.74976 15.751 8 15.751ZM7.97028 5.48204C7.36098 5.48204 6.86314 4.9842 6.86314 4.3749C6.86314 3.75074 7.36098 3.26032 7.97028 3.26032C8.57958 3.26032 9.06256 3.75074 9.06256 4.3749C9.06256 4.9842 8.57958 5.48204 7.97028 5.48204ZM6.61793 12.2066C6.23897 12.2066 5.94918 11.9466 5.94918 11.5602C5.94918 11.2035 6.23897 10.9137 6.61793 10.9137H7.50959V7.91181H6.75911C6.38758 7.91181 6.09036 7.64431 6.09036 7.26536C6.09036 6.90869 6.38758 6.61891 6.75911 6.61891H8.24521C8.72076 6.61891 8.97339 6.95328 8.97339 7.45112V10.9137H9.76103C10.1326 10.9137 10.4298 11.2035 10.4298 11.5602C10.4298 11.9466 10.1326 12.2066 9.76103 12.2066H6.61793Z",
    fill: "#5856D6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.dce6642b.svg";
export { ForwardRef as ReactComponent };